
import { Link, useParams } from "react-router-dom"
import { faExternalLink} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useQueryParams from "../../../hooks/useQueryParams"

const FriendMenu = ({response, relatedResponses}) => {
    const {groupId, taskId, responseId, friendResponse, type} = useParams()
    const { q, qName } = useQueryParams()
    if(!relatedResponses || relatedResponses.length ===0) return <></>
    const url = `?q=${encodeURIComponent( q||"")}&qName=${encodeURIComponent(qName ||"")}`
    
  return (
    <div className="friend-menu grid-collapse-2 sticky">
        <Link  to={`/${type}/${groupId}/grades/task/${taskId}/${responseId}${url}`} className={!friendResponse? "active":""}>
        <button type="button">
{response.fullname}  (ראשי {response.grade > 0 && `-${ response.grade}`})
</button>
        </Link>
    {relatedResponses.map((friend)=>{
        return <> <Link className={friendResponse === friend._id? "active":""} type="button" to={`/${type}/${groupId}/grades/task/${taskId}/${responseId}/${friend._id}${url}`}>
            <button type="button">
{  friend.fullname} {friend.grade > 0 && `(${ friend.grade})`}
</button> 
          </Link>
         <Link  className={friendResponse === friend._id? "active":""} type="button" to={`/${type}/${groupId}/grades/task/${taskId}/${friend._id}${url}`}>
            <FontAwesomeIcon  title={  friend.fullname} color="black" icon={faExternalLink} />
          </Link></>
    })}
</div>
  )
}

export default FriendMenu